import { render, staticRenderFns } from "./flowRouterManger.vue?vue&type=template&id=5186a2fe&scoped=true&"
import script from "./flowRouterManger.vue?vue&type=script&lang=js&"
export * from "./flowRouterManger.vue?vue&type=script&lang=js&"
import style0 from "./flowRouterManger.vue?vue&type=style&index=0&id=5186a2fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5186a2fe",
  null
  
)

export default component.exports